import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/global.less'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Enum from '@/utils/enum'
import HTTP from '@/utils/http'
import TOOL from '@/utils/tools'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.config.globalProperties.$store = store
app.config.globalProperties.$http = HTTP
app.config.globalProperties.$enum = Enum
app.config.globalProperties.$tool = TOOL
app.mount('#app')
